// extracted by mini-css-extract-plugin
export var actions = "_a4-8";
export var arrow = "_a4-5";
export var card = "_a4-0";
export var cardWrapper = "_a4-9";
export var fieldName = "_a4-3";
export var newValue = "_a4-6";
export var oldValue = "_a4-4";
export var orangeGlowFade = "_a4-c";
export var productSection = "_a4-1";
export var scrollToBottom = "_a4-b";
export var scrollToBottomAnchor = "_a4-a";
export var scrollToBottomIcon = "_a4-d";
export var showAllButton = "_a4-7";
export var table = "_a4-2";